import {
  Card,
  Col,
  Form,
  Input,
  Typography,
  Row,
  Button,
  Table,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiCaller } from "src/util/apiCaller";
import { messages } from "src/constants/messages";
import { FormOutlined } from "@ant-design/icons";
import Captcha from "./Captcha"; // Import component CAPTCHA

const { Title } = Typography;
const FormItem = Form.Item;

const GopYForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [listGopY, setListGopY] = useState<any[]>([]);
  const [captchaInput, setCaptchaInput] = useState<string>("");
  const [captchaValue, setCaptchaValue] = useState<string>("");

  const { validateFields, resetFields } = form;

  useEffect(() => {
    fetchListGopY(id);
    refreshCaptcha(); // Tạo CAPTCHA mới khi component mount
  }, [id]);

  const generateCaptcha = (): string => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return captcha;
  };

  const refreshCaptcha = () => {
    const newCaptcha = generateCaptcha();
    setCaptchaValue(newCaptcha); // Lưu giá trị CAPTCHA mới
    setCaptchaInput(""); // Đặt lại giá trị nhập CAPTCHA
  };

  const save = () => {
    validateFields()
      .then(async (values) => {
        if (captchaInput !== captchaValue) { // Kiểm tra CAPTCHA
          message.error("CAPTCHA không chính xác!");
          refreshCaptcha(); // Làm mới CAPTCHA nếu nhập sai
          return;
        }
        setLoadingButton(true);
        await saveData(values);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  const saveData = async (values: any) => {
    const currentDate = Date.now();

    const dataToSend = {
      idTuLieu: id,
      nguoiGopY: values.nguoiGopY,
      ngayGopY: currentDate,
      noiDungGopY: values.noidungGopY,
      noiDungTraLoi: values.noidungTraLoi || "",
      soDienThoai: values.soDienThoai,
      email: values.email,
      isSuDung: true,
    };

    try {
      const response = await apiCaller({
        url: `/apipublic/tulieugopy/create`,
        method: "POST",
        data: dataToSend,
      });

      if (response && (response.status === 200 || response.status === 201)) {
        message.success("Gửi góp ý thành công!");
        resetFields();
        fetchListGopY(id);
        refreshCaptcha(); // Tạo CAPTCHA mới sau khi gửi thành công
      }
    } catch (error) {
      message.error("Có lỗi xảy ra, vui lòng thử lại!");
    } finally {
      setLoadingButton(false);
    }
  };

  const fetchListGopY = async (id: string | undefined) => {
    try {
      const response = await apiCaller({
        url: `/apipublic/tulieugopys?ishienthi=true&idtulieu=${id}`,
        method: "GET",
      });

      if (response && Array.isArray(response.data.content)) {
        setListGopY(response.data.content);
      } else {
        setListGopY([]);
      }
    } catch (error) {}
  };

  const columns = [
    {
      title: "Người Góp Ý",
      dataIndex: "nguoiGopY",
      key: "nguoiGopY",
    },
    {
      title: "Ngày Góp Ý",
      dataIndex: "ngayGopY",
      key: "ngayGopY",
      render: (text: number) => new Date(text).toLocaleDateString("vi-VN"),
    },
    {
      title: "Số Điện Thoại",
      dataIndex: "soDienThoai",
      key: "soDienThoai",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  return (
    <div className="QTI-content-home">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Col md={12}>
          <Title level={4}>
            <FormOutlined style={{ marginRight: "8px" }} />
            Góp ý
          </Title>
        </Col>
      </div>
      <Card className="QTI-card-gopy">
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="gop-y-control"
        >
          <Row gutter={24}>
            <Col md={24}>
              <Row gutter={24}>
                <Col md={8} xs={24}>
                  <FormItem
                    label="Người góp ý"
                    name="nguoiGopY"
                    rules={[{ required: true, message: messages.ERROR_REQUIRED }]}
                  >
                    <Input placeholder="Nhập tên người góp ý" />
                  </FormItem>
                </Col>
                <Col md={8} xs={24}>
                  <FormItem
                    label="Số điện thoại"
                    name="soDienThoai"
                    rules={[
                      { required: true, message: messages.ERROR_REQUIRED },
                      {
                        pattern: /^[0-9]{10,11}$/,
                        message: "Số điện thoại không hợp lệ!",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập số điện thoại" />
                  </FormItem>
                </Col>
                <Col md={8} xs={24}>
                  <FormItem
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: messages.ERROR_REQUIRED },
                      {
                        type: "email",
                        message: "Email không hợp lệ!",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập email" />
                  </FormItem>
                </Col>
              </Row>
            </Col>
            <Col md={24} xs={24}>
              <FormItem
                label="Nội dung góp ý"
                name="noidungGopY"
                rules={[{ required: true, message: messages.ERROR_REQUIRED }]}
              >
                <Input.TextArea placeholder="Nhập nội dung góp ý" />
              </FormItem>
            </Col>
          </Row>
          <Captcha 
              onChange={setCaptchaInput} 
              currentCaptcha={captchaValue}
          />
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
            <Button type="primary" loading={loadingButton} onClick={save}>
              Gửi góp ý
            </Button>
          </div>
        </Form>
      </Card>
      <Card className="QTI-card-gopy" style={{ marginTop: 20 }}>
        <Table
          columns={columns}
          dataSource={listGopY.map((item) => ({
            ...item,
            key: item.id,
          }))}
          rowKey="id"
          className="qti-table-wrapper gx-table-responsive"
        />
      </Card>
    </div>
  );
};

export default GopYForm;